import { languageCodes } from '@concur/intl-core';
export function normalizeLanguageCode(code) {
    var _a, _b, _c;
    var baseLang = ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NUI_BASE_LANGUAGE) || 'en';
    var supportedLangs = languageCodes;
    if (code === null || code === undefined) {
        return baseLang;
    }
    var replacedLang = code.replace(/-\d+/, '').toLowerCase().replace('_', '-').replace('-gsa', '');
    return ((_c = (_b = supportedLangs.find(function (l) { return l === replacedLang; })) !== null && _b !== void 0 ? _b : supportedLangs.find(function (l) { return l === replacedLang.replace(/-.+/, ''); })) !== null && _c !== void 0 ? _c : baseLang);
}
